import currentLocale from 'src/locales';

function t(key: string) {
  return currentLocale[key] || key;
}

const translation = { t };

export default translation;
